import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getMovie, posterUrl, videoUrl, audioUrl } from "@/lib/api";
import MoviePlayer from "@/components/MoviePlayer";
import { Loader2 } from "lucide-react";

export default function Share() {
  const { id } = useParams();
  const [movie, setMovie] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const m = await getMovie(id);
        if (!cancelled) setMovie(m);
      } catch {
        if (!cancelled) setMovie({ error: true });
      }
    };
    load();
  }, [id]);

  if (!movie) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505]">
        <Loader2 className="h-6 w-6 animate-spin text-white/40" />
      </div>
    );
  }
  if (movie.error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#050505] text-white/60">
        Reel not found.
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <div className="mx-auto max-w-[1100px] px-6 py-14 md:py-20">
        <div className="mb-4 flex items-center justify-between">
          <div className="font-mono-ui text-[10px] uppercase tracking-[0.34em] text-[#E50914]">
            A Free Determinism Production · Reelforge Studio
          </div>
          <Link
            to="/"
            data-testid="share-cta-home"
            className="border border-white/10 px-4 py-2 font-mono-ui text-[10px] uppercase tracking-[0.28em] text-white/70 hover:border-[#E50914] hover:text-white"
          >
            Make your own
          </Link>
        </div>

        <h1
          data-testid="share-title"
          className="font-display text-5xl font-black leading-[0.95] tracking-tight md:text-7xl"
        >
          {movie.title || "Untitled Reel"}
        </h1>
        {movie.logline && (
          <p className="mt-4 max-w-2xl font-display italic text-lg text-white/70 md:text-xl">
            &ldquo;{movie.logline}&rdquo;
          </p>
        )}

        <div className="mt-10">
          {movie.has_video ? (
            <MoviePlayer movie={movie} />
          ) : (
            <div className="flex h-64 items-center justify-center border border-white/10 bg-[#0A0A0A] font-mono-ui text-[11px] uppercase tracking-[0.28em] text-white/50">
              Still rendering…
            </div>
          )}
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-6 font-mono-ui text-[11px] uppercase tracking-[0.24em] text-white/50">
          <span>{movie.num_scenes || 1} scene{(movie.num_scenes || 1) > 1 ? "s" : ""} · {(movie.num_scenes || 1) * movie.duration}s · {movie.music_mood || "ambient"} score</span>
          <span>Created by Kyle Hamilton</span>
        </div>
      </div>
    </div>
  );
}
